import { BitfODataRequestMapper } from '@bitf/core/parsers/odata-parser/bitf-odata-request.mapper';
import { EBitfParsers } from '@enums';

export class AppRequestMapper extends BitfODataRequestMapper {
  name = EBitfParsers.BITF_APP_PARSER;
}
